import { gql } from '@apollo/client';

export const UPDATE_LAB_ANALYSIS_INSTANCE_IN_PROPERTY_ALL_FIELDS = gql`
  mutation addOrUpdateLabAnalysisInstanceInProperty($input: AddOrUpdateLabAnalysisInstanceInPropertyInput!) {
    addOrUpdateLabAnalysisInstanceInProperty(input: $input) {
      clientMutationId
      errors
      labAnalysisInstanceUuid
      propertyUuid
      labAnalysisInstance {
        id
        narrative
        analysisPerformedBy {
          id
          name
          oriId
          position
        }
        analysisRequestType {
          id
          name
          oriId
          position
        }
      }
    }
  }
`